export interface ToggleMenuAction {
    type: 'layout/TOGGLE_MENU';
}

export const toggleMenu = (): ToggleMenuAction => ({
    type: 'layout/TOGGLE_MENU',
});

export type LayoutAction = ToggleMenuAction;
